import { getOnboardingPreferencesUpdated } from '@stores/selectors/common';
import { useRouter } from 'next/router';
import useOnboardingStore from '@stores/goal/onboarding';

import useFirstRenderSkip from './useFirstRenderSkip';

const useRefreshDataOnGloUpdate = (fetchDataCallback) => {
  const {
    query: { goalUID }
  } = useRouter();
  const areGoalOnBoardingPreferencesUpdated = useOnboardingStore(
    getOnboardingPreferencesUpdated(goalUID)
  );

  useFirstRenderSkip(() => {
    if (areGoalOnBoardingPreferencesUpdated) {
      fetchDataCallback();
    }
  }, [areGoalOnBoardingPreferencesUpdated]);
};

export default useRefreshDataOnGloUpdate;
